
import styles from "./ediror.module.scss";
import { HandySvg } from "handy-svg";
import { useEffect, useState } from "react";
import {  getPerson, getCardsList } from "../../../pages/api/sportcards";
import { useStore } from "../../../stores/use_global_state";
import { defoltData } from "../constatns";
import { useRouter } from "next/router";
import ChoosePerson from "./choosePerson";
import UploadPhoto from "./uploadPhoto";
import Template from "./template";
import Pose from "./pose";
import Background from "./background";
import Logo from "./logo";
import Text from "./text";
import Download from "./download";


export const Editor = ({ activeStep, setSteps, sportCardsState, setSportCardsState }) => {
  const { state } = useStore();
  let token = state?.userInfo?.token ? state.userInfo.token : false;
  const [title, setTitle] = useState("");
  const [isReady, setisReady] = useState(false);
  const router = useRouter();
  const [openFolder, setOpenFolder] = useState(null);


  useEffect(() => {
    const getTitle = async () => {
      if (activeStep.name === "Selfie" && sportCardsState.person === null) return setTitle("Choose the person or create new");
      if (activeStep.name === "Selfie" && sportCardsState.person !== null) return setTitle("Upload selfies");
      if (activeStep.name === "Template") return setTitle("Select template");
      if (activeStep.name === "Background") return setTitle("Select background");
      if (activeStep.name === "Pose") return setTitle("Select pose");
      if (activeStep.name === "Logo") return setTitle("Upload logo");
      if (activeStep.name === "Text") return setTitle("Add text");

      const personData = await getPerson(sportCardsState?.person?.id, token);
      if (activeStep.name === "Download" && personData?.status !== "READY") return setTitle("Your card is almost ready!");
      if (activeStep.name === "Download" && personData?.status === "READY") return (setTitle("Select preview and download card"), setisReady(true));
    }

    getTitle()
  }, [activeStep])

  const backHandler = () => {
    const { template, person } = sportCardsState

    if (activeStep.name === "Selfie") return person === null ? router.push({ pathname: "/" }) : setSportCardsState({ ...defoltData });
    if (activeStep.name === "Template") {
      if (person.status !== "CREATED") { setSportCardsState({ ...defoltData }); }
      return setSteps(prev => prev.map(step => ({ ...step, active: step.name === "Selfie" })))
    };
    if (activeStep.name === "Background") return setSteps(prev => prev.map(step => ({ ...step, active: step.name === "Template" })));
    if (activeStep.name === "Pose") return setSteps(prev => prev.map(step => ({ ...step, active: step.name === "Background" })));
    if (activeStep.name === "Logo") return setSteps(prev => prev.map(step => ({ ...step, active: step.name === "Pose" })));
    if (activeStep.name === "Text") return setSteps(prev => prev.map(step => ({ ...step, active: step.name === "Logo" })));
    if (activeStep.name === "Download" && openFolder === null) return setSteps(prev => prev.map(step => ({ ...step, active: template === null ? step.name === "Template" : step.name === "Text" })));
    if (activeStep.name === "Download" && openFolder !== null) return setOpenFolder(null);
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (activeStep?.name === "Download" && sportCardsState?.person) {
        const getCArdData = async () => {
          const { data } = await getCardsList(sportCardsState?.person.id, token);
          setSportCardsState({ ...sportCardsState, person: { ...sportCardsState?.person, token, cards: data } });
        }

        getCArdData();
      }
    }, 2500);

    return () => clearTimeout(timeout);
  }, [activeStep, sportCardsState])

  return (
    <div className={styles.editor}>
      <div className={styles.topWrapper}>
        <button className={styles.btnBack} onClick={backHandler}><HandySvg src="/illustration_service/back.svg" width={18} height={18} className={styles.item_next} />Back</button>
        <h2 className={styles.title}>{title}</h2>
      </div>
      {activeStep.name === "Selfie" && sportCardsState.person === null && <ChoosePerson {...{ setSteps, setSportCardsState, sportCardsState }} />}
      {activeStep.name === "Selfie" && sportCardsState.person !== null && <UploadPhoto {...{ setSteps, setSportCardsState, sportCardsState }} />}
      {activeStep.name === "Template" && <Template {...{ setSteps, setSportCardsState, sportCardsState }} />}
      {activeStep.name === "Pose" && <Pose {...{ setSteps, setSportCardsState, sportCardsState }} />}
      {activeStep.name === "Background" && <Background {...{ setSteps, setSportCardsState, sportCardsState }} />}
      {activeStep.name === "Logo" && <Logo {...{ setSteps, setSportCardsState, sportCardsState }} />}
      {activeStep.name === "Text" && <Text {...{ setSteps, setSportCardsState, sportCardsState }} />}
      {activeStep.name === "Download" && !isReady && <Download {...{ setSteps, setSportCardsState, sportCardsState, isReady, openFolder, setOpenFolder }} />}

    </div>
  );
}

export default Editor